import { Box, Typography } from "@mui/material";
import { MemoryForm } from "../../components/MemoryForm";

export const Herinnering = () => {
  return (
    <Box sx={{ textAlign: "center", mt: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Deel een herinnering of boodschap
      </Typography>
      <Typography variant="body1" paragraph sx={{ textAlign: "center", mt: 2 }}>
        Help mee om Erwin te herinneren door mooie momenten, foto's, video's of
        lieve woorden te delen. Elke herinnering, groot of klein, betekent
        veel voor de familie en vrienden.
      </Typography>
      <Typography variant="body1" paragraph sx={{ textAlign: "center", mt: 1 }}>
        Samen maken we een blijvende verzameling van bijzondere momenten die
        laten zien wie Erwin was en wat hij voor ons heeft betekend.
      </Typography>

      <MemoryForm />
    </Box>
  );
};
